import { ReactNode, useEffect, useState } from "react";
import QRCode from "qrcode.react";
import {
  QRCODE_QUERY_MAP,
  rechargeChannelsCode,
} from "project-config/constants";
import RefreshIcon from "@/assets/icons/topup/refresh-icon";
import { isDev } from "project-config/utils/env";
import Wechat from "../../icons/Wechatpay";
import Alipay from "../../icons/Alipay";
import { useGlobalStore } from "@/store/GlobalStore";
import { getUserKey } from "@/utils/getUesrKey";
import { useTimestamp } from "@/hooks/use-timestamp";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import { useClientTopUpStore } from "../../store";
import {
  Gift,
  HiddenTopLeft,
  PayType,
  PaymentContent,
  PaymentWayWrapper,
  Price,
  QRCodeContainer,
  QRCodeDisabledProtocol,
  QRCodeLoading,
  RechargeArrivalContent,
  RefreshButton,
} from "./atom";
import {
  BalanceTipType,
  ExtraWelfareTipType,
  ExtraWelfareType,
} from "../../help/tips";
import { PaySuccessSocket } from "../pay-socket";
import RechargeArrival from "../../images/recharge-arrival.png";

import {
  BalanceIcon,
  GiftCouponIcon,
  GiftVipIcon,
  IsMemberIcon,
} from "../../icons";
import RightArrow from "../../icons/RightArrow";
import { MemberLevelProps } from "../../constants";

export function PaymentWay({
  account,
  activityDetailItem,
  qrcodeLink,
  onClickCantScanCode,
  paying,
  extra,
  disabledProtocol,
  balanceTip,
  extraTip,
  isVipRecharge,
}: {
  account: number;
  activityDetailItem?: MemberLevelProps;
  qrcodeLink?: string;
  onClickCantScanCode?: () => void;
  paying?: boolean;
  extra?: ReactNode;
  disabledProtocol?: boolean;
  balanceTip?: BalanceTipType[];
  extraTip?: ExtraWelfareTipType[];
  isVipRecharge?: boolean;
}) {
  const { userInfo, languageFlag, currencySymbol, isCertified } =
    useGlobalStore();
  const { userProperty } = useUserPropertyStore();
  const isSubmitTask = userProperty?.isSubmitTask;
  const [localTimestamp, setLocalTimestamp] = useState(Date.now());
  const { timestamp, fetchTimestamp } = useTimestamp();
  const { hasScanned, setHasScanned, rechargeSecondActiveName } =
    useClientTopUpStore();
  const userKey = getUserKey();
  const host = isDev()
    ? "https://task-pre.renderbus.com"
    : "https://task.renderbus.com";
  const decimal = String(account).split(".")[1] || "";
  const wholeText = () => {
    const noCertifiedSubmit =
      !isCertified && !Boolean(isSubmitTask) ? "1" : "0";
    const paramStr = `${host}/mobile-pay?${QRCODE_QUERY_MAP.platform}=${userInfo?.platform}&${QRCODE_QUERY_MAP.timeStamp}=${timestamp}&${QRCODE_QUERY_MAP.languageFlag}=${languageFlag}&${QRCODE_QUERY_MAP.userKey}=${userKey}${qrcodeLink}&${QRCODE_QUERY_MAP.noCertifiedSubmit}=${noCertifiedSubmit}&${QRCODE_QUERY_MAP.rechargeChannels}=${rechargeChannelsCode.Client}`;
    return paramStr;
  };

  const disabledQrCode = () => {
    return (
      !account ||
      Number.isNaN(account) ||
      (rechargeSecondActiveName !== "client-second-tab-first-recharge" &&
        5 > account) ||
      (rechargeSecondActiveName === "client-second-tab-first-recharge" &&
        1 > account) ||
      account > 200000 ||
      decimal.length > 2
    );
  };

  const balanceTipList = balanceTip?.filter(
    (item: any) => item.content.length > 0
  );
  const extraTipList = extraTip?.filter((item: any) => item.content.length > 0);
  const vipItem = extraTipList?.find(
    (item) => item.type === ExtraWelfareType.VIP
  );

  const refreshCode = () => {
    fetchTimestamp().catch(console.trace);
    setLocalTimestamp(Date.now());
    setHasScanned(false);
  };

  useEffect(() => {
    if (disabledProtocol === true) {
      return;
    }
    if (!isCertified && !Boolean(isSubmitTask)) {
      const timer = setInterval(refreshCode, 10000);
      return () => clearInterval(timer);
    }
    const timer = setInterval(() => {
      if (Date.now() - localTimestamp > 1000 * 60 * 3) {
        refreshCode();
      }
    }, 1000 * 3);
    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localTimestamp, isCertified, isSubmitTask, disabledProtocol]);

  useEffect(() => {
    if (disabledProtocol === false) {
      refreshCode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabledProtocol]);

  return (
    <PaymentWayWrapper>
      <PaySuccessSocket />
      <PaymentContent>
        <Price>
          <span>实付</span>
          <span className={"unit"}>{currencySymbol}</span>
          <span className={"price"}>{Number(account)} </span>
        </Price>
        <QRCodeContainer>
          <QRCode size={131} value={wholeText()} />
          {disabledQrCode() && <QRCodeLoading />}
          {disabledQrCode() && <HiddenTopLeft />}
          {disabledProtocol && (
            <QRCodeDisabledProtocol>
              请勾选效果图会员协议后扫码支付
            </QRCodeDisabledProtocol>
          )}
          {hasScanned && (
            <RefreshButton onClick={refreshCode}>
              <RefreshIcon />
              <span>手动刷新</span>
            </RefreshButton>
          )}
        </QRCodeContainer>
        {isVipRecharge ? (
          <Gift className="vip-gift">
            <IsMemberIcon style={{ marginRight: 4 }} />
            <span className="member">效果图会员</span>
            <span className="month">
              {vipItem ? vipItem.content[0] : activityDetailItem?.vipMonth}
              个月
            </span>
          </Gift>
        ) : (
          <RechargeArrivalContent>
            <img src={RechargeArrival} alt="" className="arrival-bg" />
            {balanceTipList && balanceTipList.length > 0 && (
              <Gift>
                <BalanceIcon />
                <span>余额</span>&nbsp;
                <span>{balanceTipList[0].content}</span>
              </Gift>
            )}
            {extraTipList && extraTipList.length > 0 && (
              <>
                {extraTipList.map((item, index: number) => (
                  <Gift key={index}>
                    {item.type === ExtraWelfareType.VIP ? (
                      <GiftVipIcon />
                    ) : (
                      <GiftCouponIcon />
                    )}
                    <span>{item.pre}</span>&nbsp;
                    <span className="gift-num">
                      <span>{item.contentPre}</span>
                      <span>
                        {Number(
                          item.content
                            .reduce((acc, v) => acc + Number(v), 0)
                            .toFixed(2)
                        )}
                      </span>
                      <span>{item.contentSuf}</span>
                    </span>
                  </Gift>
                ))}
              </>
            )}
          </RechargeArrivalContent>
        )}
      </PaymentContent>
      <PayType>
        {extra}
        <div className="pay-item">
          <Wechat />
          <span>使用微信扫码支付</span>
        </div>
        <div className="pay-item">
          <Alipay />
          <span>支付宝扫码或</span>
          <button
            onClick={() => {
              onClickCantScanCode?.();
            }}
            disabled={disabledQrCode() || disabledProtocol}
            className={disabledQrCode() || disabledProtocol ? "disabled" : ""}
          >
            &nbsp;
            {paying ? "wait..." : "网页支付"}
            {!paying && <RightArrow className="right-icon" />}
          </button>
        </div>
      </PayType>
    </PaymentWayWrapper>
  );
}
